import { api } from '@here/api'

/**
 * Deletes a setup by its ID.
 * @param {string} id - The ID of the setup to delete.
 * @returns {Object|null} The deleted setup data, or null if deletion fails.
 */
export const getProfiles = async (username: string) => {
	if (username === '') {
		return []
	}

	const { data, error } = await api()
		.from('profile')
		.select('*')
		.ilike('username', `%${username}%`) // Case-insensitive LIKE

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	return data
}
